module.exports = __webpack_public_path__ + "img/logoWhite.c4d64109.png";